import { debounce, filter, includes } from 'lodash';
import React, { useState } from 'react';

import { StyledItem, StyledWrapper } from './Accordion.styles';
import { IAccordionProps } from './Accordion.types';
import AccordionButton from './AccordionButton';
import AccordionPanel from './AccordionPanel';

const Accordion = ({
  ariaLabel = 'Show/hide',
  autoClose = false,
  boxed = false,
  className,
  content,
  id,
  user = 'landlord',
}: IAccordionProps): JSX.Element => {
  const [active, setActive] = useState<number[]>([]);

  return (
    <StyledWrapper boxed={boxed} id={id} user={user} className={className}>
      {content &&
        content.map((item, index) => {
          const { body, title } = item;
          const itemID = `${id}-${index}`;
          const setAccordionState = (index: number) => {
            if (includes(active, index)) {
              setActive(currentActive =>
                filter([...currentActive], n => n !== index),
              );
            } else {
              if (autoClose) {
                setActive([index]);
              } else {
                setActive(currentActive => [...currentActive, ...[index]]);
              }
            }
          };
          const handleOnKeyDown = (
            e: React.KeyboardEvent<HTMLButtonElement>,
            index: number,
          ) => {
            if (e.key === 'Enter' || e.key === ' ') {
              setAccordionState(index);
            }
          };

          return (
            <StyledItem key={itemID}>
              <AccordionButton
                active={includes(active, index)}
                ariaLabel={ariaLabel}
                id={itemID}
                title={title}
                onClick={() => setAccordionState(index)}
                onKeyDown={e =>
                  debounce(() => {
                    handleOnKeyDown(e, index);
                  }, 300)
                }
              />
              <AccordionPanel
                active={includes(active, index)}
                id={itemID}
                body={body}
              />
            </StyledItem>
          );
        })}
    </StyledWrapper>
  );
};

export default Accordion;
